import {storage} from "../firebase";

export const uploadMediaToStorage = (file: any, path: string) => {
    const fileRef = storage.ref().child(path);

    return fileRef.put(file).then((task) => task.ref.getDownloadURL());
};